import { useQuery } from '@tanstack/react-query'
import { fetchEstadisticasDetalladas, fetchEstadisticasPorNewsletter } from '../api/estadisticas.api'

export function useEstadisticas(dias: number) {
  return useQuery({
    queryKey: ['estadisticas-enterprise', dias],
    queryFn: () => fetchEstadisticasDetalladas(dias),
  })
}

export function useEstadisticasPorNewsletter(anio: number, meses: string[]) {
  return useQuery({
    queryKey: ['estadisticas-por-newsletter', anio, meses],
    queryFn: () => fetchEstadisticasPorNewsletter(anio, meses),
    enabled: meses.length > 0,
  })
}
